module.exports = __webpack_public_path__ + "static/media/box_office_collection_bg.2b608367.png";